export const MAIL_STATUS_UI = {
  sent: {
    key: 'sent',
    label: 'Enviado',
    metricLabel: 'Enviados',
    description: 'El correo fue enviado al proveedor de correo.',
    color: '#1976d2',
    backgroundColor: '#ebf8ff',
    metricField: 'received',
    icon: 'send',
  },
  delivered: {
    key: 'delivered',
    label: 'Entregado',
    metricLabel: 'Entregados',
    description: 'El correo fue entregado al servidor del destinatario.',
    color: '#2e7d32',
    backgroundColor: '#e6ffed',
    metricField: 'delivered',
    icon: 'mark_email_read',
  },
  opened: {
    key: 'opened',
    label: 'Abierto',
    metricLabel: 'Abiertos',
    description: 'El destinatario abrio el correo.',
    color: '#00897b',
    backgroundColor: '#e0f7f4',
    metricField: 'opened',
    icon: 'visibility',
  },
  clicked: {
    key: 'clicked',
    label: 'Clic',
    metricLabel: 'Clics',
    description: 'El destinatario hizo clic en un enlace del correo.',
    color: '#6a1b9a',
    backgroundColor: '#f3e5f5',
    metricField: 'clicked',
    icon: 'link',
  },
  queued: {
    key: 'queued',
    label: 'En cola',
    metricLabel: 'En cola',
    description: 'El correo esta pendiente de procesamiento o reintento.',
    color: '#ed6c02',
    backgroundColor: '#fff8e1',
    metricField: 'queue',
    icon: 'hourglass',
  },
  bounced: {
    key: 'bounced',
    label: 'Rebotado',
    metricLabel: 'Rebotados',
    description: 'El correo fue rechazado o rebotado por el destino.',
    color: '#d32f2f',
    backgroundColor: '#ffebee',
    metricField: 'temporaryBounces',
    icon: 'report_problem',
  },
  blocked: {
    key: 'blocked',
    label: 'Bloqueado',
    metricLabel: 'Bloqueados',
    description: 'Mailjet bloqueo el envio antes de entregarlo.',
    color: '#c62828',
    backgroundColor: '#fdecea',
    metricField: 'blocked',
    icon: 'block',
  },
  spam: {
    key: 'spam',
    label: 'Spam',
    metricLabel: 'Spam',
    description: 'El destinatario reporto el correo como spam.',
    color: '#ad1457',
    backgroundColor: '#fce4ec',
    metricField: 'spam',
    icon: 'report',
  },
  unsubscribed: {
    key: 'unsubscribed',
    label: 'Baja',
    metricLabel: 'Bajas',
    description: 'El destinatario se desuscribio.',
    color: '#455a64',
    backgroundColor: '#eceff1',
    metricField: 'unsubscribed',
    icon: 'person_remove',
  },
  failed: {
    key: 'failed',
    label: 'Fallido',
    metricLabel: 'Fallidos',
    description: 'El correo no pudo enviarse correctamente.',
    color: '#c62828',
    backgroundColor: '#fdecea',
    metricField: 'failed',
    icon: 'error',
  },
  unknown: {
    key: 'unknown',
    label: 'Sin estado',
    metricLabel: 'Sin estado',
    description: 'El estado no fue reconocido por el sistema.',
    color: '#616161',
    backgroundColor: '#f5f5f5',
    metricField: null,
    icon: 'help',
  },
};

const MAIL_STATUS_ALIASES = {
  sent: 'sent',
  send: 'sent',
  enviado: 'sent',
  received: 'sent',

  delivered: 'delivered',
  entregado: 'delivered',

  open: 'opened',
  opened: 'opened',
  abierto: 'opened',

  click: 'clicked',
  clicked: 'clicked',
  clic: 'clicked',

  queue: 'queued',
  queued: 'queued',
  retrying: 'queued',
  deferred: 'queued',
  processing: 'queued',
  sending: 'queued',
  waiting: 'queued',
  'in queue': 'queued',
  encola: 'queued',
  'en cola': 'queued',

  bounce: 'bounced',
  bounced: 'bounced',
  temporarybounce: 'bounced',
  temporarybounces: 'bounced',
  'temporary bounce': 'bounced',
  'temporary bounces': 'bounced',
  'soft bounce': 'bounced',
  'hard bounce': 'bounced',
  rebotado: 'bounced',

  blocked: 'blocked',
  preblocked: 'blocked',
  bloqueado: 'blocked',

  spam: 'spam',

  unsub: 'unsubscribed',
  unsubscribe: 'unsubscribed',
  unsubscribed: 'unsubscribed',
  baja: 'unsubscribed',

  failed: 'failed',
  fail: 'failed',
  error: 'failed',
  invalid: 'failed',
  'invalid email': 'failed',
  fallido: 'failed',
};

const normalizeKey = (status) =>
  String(status || '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ');

export const getStatsResult = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.result)) return data.result;
  return [];
};

export const getMailStatusUi = (status) => {
  const key = MAIL_STATUS_ALIASES[normalizeKey(status)] || 'unknown';
  return MAIL_STATUS_UI[key];
};

const buildMetrics = (item) =>
  Object.values(MAIL_STATUS_UI)
    .filter((status) => status.metricField)
    .map((status) => ({
      key: status.key,
      label: status.metricLabel,
      description: status.description,
      value: item[status.metricField] ?? 0,
      color: status.color,
      backgroundColor: status.backgroundColor,
      icon: status.icon,
    }));

const normalizeMailList = (listaCorreos) =>
  listaCorreos?.map((mail) => {
    const statusUi = getMailStatusUi(mail.estado);

    return {
      ...mail,
      estadoOriginal: mail.estado,
      estadoNormalizado: statusUi.key,
      estado: statusUi.label,
      estadoLabel: statusUi.label,
      estadoColor: statusUi.color,
      estadoBackgroundColor: statusUi.backgroundColor,
      estadoDescription: statusUi.description,
    };
  }) ?? [];

const normalizeMailStatsItem = (item) => ({
    ...item,
    metrics: buildMetrics(item),
    listaCorreos: normalizeMailList(item.listaCorreos),
  });

export const normalizeMailStats = (data) =>
  getStatsResult(data).map((item) => ({
    ...normalizeMailStatsItem(item),
    enviosPorFecha: item.enviosPorFecha?.map(normalizeMailStatsItem),
  }));
